import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderDropoffVerificationSchema = {
    signature: Schema.String,
    pin_code: Schema.Number,
    identification: Schema.String,
    picture: Schema.Auto,
    barcodes: Schema.Auto,
};
